import { render } from "./DiagramPropsCmp.vue?vue&type=template&id=5b051aaa"
import script from "./DiagramPropsCmp.vue?vue&type=script&lang=js"
export * from "./DiagramPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__